import { ResizeObserver } from '@juggle/resize-observer';
import { useEventHandler } from '@superdispatch/hooks';
import { useLayoutEffect } from 'react';
export function useResizeObserver(node, observer) {
  var handler = useEventHandler(observer);
  useLayoutEffect(() => {
    if (!node) {
      return;
    }
    var resizeObserver = new ResizeObserver(() => {
      handler(node);
    });
    resizeObserver.observe(node);
    handler(node);
    return () => {
      resizeObserver.disconnect();
    };
  }, [node, handler]);
}